import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../../utils';
import { partnerApiPath } from '../../../apiPath';
import { partnerHttpClient } from '../../../httpClient';

const RecruitmentProgressStatusSchema = z
  .enum(['BEFORE_RECRUITMENT', 'RECRUITING', 'IN_PROGRESS', 'COMPLETED'])
  .describe('RecruitmentProgressStatusSchema');

const GetRecruitmentCampaignsCountRequestSchema = z
  .object({
    platform: z.string(),
    progressStatus: RecruitmentProgressStatusSchema,
    title: z.string().nullable().optional(),
    brandIds: z.array(z.string()).nullable().optional(),
  })
  .describe('GetRecruitmentCampaignsCountRequestSchema');

export type GetRecruitmentCampaignsCountRequest = z.infer<
  typeof GetRecruitmentCampaignsCountRequestSchema
>;

const GetRecruitmentCampaignsCountResponseDataSchema = z
  .object({
    totalCount: z.number(),
  })
  .describe('GetRecruitmentCampaignsCountResponseDataSchema');

const GetRecruitmentCampaignsCountResponseSchema = createApiResponseSchema(
  GetRecruitmentCampaignsCountResponseDataSchema,
);

export type GetRecruitmentCampaignsCountResponse = z.infer<
  typeof GetRecruitmentCampaignsCountResponseSchema
>;

export const getRecruitmentCampaignsCount = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetRecruitmentCampaignsCountRequestSchema),
    async (params: GetRecruitmentCampaignsCountRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetRecruitmentCampaignsCountResponse>(
          partnerApiPath.getRecruitmentCampaignsCount,
          params,
        ),
      ),
    validateApiResponse(GetRecruitmentCampaignsCountResponseSchema),
  ),
);
